<template>
    <div class="sb-hotel-product-card">
        <LazyUiProductsCardsHotelProductCard
            v-editable="blok"
            :blok="blok"
            :mobile-breakpoint="screens.sm"
            :product-data="productData"
            :airport-data="airportData"
            :type="type"
        />
    </div>
</template>

<script lang="ts" setup>
import screens from '#tailwind-config/theme/screens';

enum ProductCardType {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
    MINI_HORIZONTAL = 'mini-horizontal',
}

defineProps<{
    blok: any;
    type: ProductCardType;
    productData: any;
    airportData?: any;
}>();
</script>

<style lang="postcss" scoped>
.sb-hotel-product-card {
    @apply w-full;
}
</style>
